import React from 'react';
import ReactDOM from 'react-dom/client';
import * as Sentry from '@sentry/react';
import { initSentry } from './sentry';
import App from './App.jsx';
import PublicSessionLinkPage from './sessions/share-link/PublicSessionLinkPage';
import { SESSION_LINK_PAGE_PATH } from './sessions/share-link/publicSessionLinkService';
import './i18n'; // Initialise i18next AVANT le render (locales vides en vague 0).
import './index.css';

// ─── Sentry — tracking d'erreurs frontend ────────────────────────────────────
// No-op si REACT_APP_SENTRY_DSN n'est pas défini au build (dev local par ex).
// Le DSN est injecté par CRA au moment du build à partir de l'environnement,
// pas au runtime — REACT_APP_* est donc gelé dans le bundle produit.
// Configuration et masquage des données personnelles : cf. ./sentry.js.
initSentry();

// ErrorBoundary Sentry : capture les exceptions de rendu React qui ne seraient
// pas déjà remontées par le global handler. Fallback minimal pour ne pas
// bloquer l'utilisateur — l'objectif est d'éviter un écran blanc silencieux.
const Fallback = () => (
  <div style={{
    padding: '40px 20px',
    textAlign: 'center',
    fontFamily: "'Inter', sans-serif",
    color: '#1a1a2e',
  }}>
    <h1 style={{ fontSize: '20px', marginBottom: '12px', color: '#BF311A' }}>
      Une erreur est survenue
    </h1>
    <p style={{ fontSize: '14px', color: '#4A5568' }}>
      L'application a rencontré un problème inattendu. Rechargez la page pour continuer.
    </p>
    <button
      type="button"
      onClick={() => window.location.reload()}
      style={{
        marginTop: '16px', padding: '10px 20px',
        background: '#1B77F1', color: '#fff',
        border: 'none', borderRadius: '8px',
        fontSize: '14px', fontWeight: '600', cursor: 'pointer',
      }}
    >
      Recharger
    </button>
  </div>
);

// Lien de séance (D247) : page publique montée à la place de <App />, pour
// qu'aucun appel authentifié (refresh, profil) ne parte au chargement.
const isSessionLinkPage = window.location.pathname === SESSION_LINK_PAGE_PATH;

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Sentry.ErrorBoundary fallback={<Fallback />}>
      {isSessionLinkPage ? <PublicSessionLinkPage /> : <App />}
    </Sentry.ErrorBoundary>
  </React.StrictMode>
);

// PWA — SW enregistré en prod uniquement (en dev, webpack-dev-server sert des
// bundles instables qui pollueraient le cache). Le fichier SW reste servi tel
// quel depuis /public pour couvrir le scope racine.
if ('serviceWorker' in navigator && process.env.NODE_ENV === 'production') {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/service-worker.js').catch((err) => {
      console.warn('SW registration failed:', err);
    });
  });
}
